/* eslint-disable @typescript-eslint/no-explicit-any */
import { routes } from '../routes.js';
import { z } from 'zod';
export const getRoute = (...parameters) => {
    const [route, options] = parameters;
    let path = route;
    if (options?.args) {
        for (const [key, value] of Object.entries(options.args)) {
            path = path.replace(`@${key}`, value);
        }
    }
    let search = '';
    if (options?.search) {
        const urlSearchParameters = new URLSearchParams();
        for (const [key, value] of Object.entries(options.search)) {
            if (value !== undefined) {
                urlSearchParameters.set(key, String(value));
            }
        }
        if (Array.from(urlSearchParameters.keys()).length > 0) {
            search = `?${urlSearchParameters.toString()}`;
        }
    }
    return path + search;
};
export const getUrl = (...parameters) => {
    const route = getRoute(...parameters);
    let origin = 'https://contra.com';
    if (typeof window !== 'undefined') {
        origin = window.location.origin;
    }
    else if (typeof process !== 'undefined') {
        // eslint-disable-next-line n/no-process-env
        origin = process.env.CAS_WEB_APP_URL ?? origin;
    }
    const url = new URL(route, origin);
    return url.toString();
};
export const getImageMediaUrl = (uid, options = {}) => {
    const extension = options.format ? `.${options.format}` : '';
    const transformations = [
        options.width ? `w_${options.width}` : undefined,
        options.height ? `h_${options.height}` : undefined,
        options.radius ? `r_${options.radius}` : undefined,
    ]
        .filter(Boolean)
        .join(',');
    const transformationsPart = transformations ? `${transformations}/` : '';
    return new URL(`https://media.contra.com/image/upload/${transformationsPart}${uid}${extension}`).toString();
};
export const getVideoMediaUrl = (uid, options = {}) => {
    const extension = options.format ? `.${options.format}` : '';
    const transformations = [
        options.width ? `w_${options.width}` : undefined,
        options.height ? `h_${options.height}` : undefined,
        options.radius ? `r_${options.radius}` : undefined,
    ]
        .filter(Boolean)
        .join(',');
    const transformationsPart = transformations ? `${transformations}/` : '';
    const baseUrl = options.format === 'avif'
        ? 'https://media.contra.com'
        : 'https://res.cloudinary.com/contra';
    return new URL(`${baseUrl}/video/upload/${transformationsPart}${uid}${extension}`).toString();
};
export const deserializeBooleanValue = (value) => {
    if (value === null) {
        return undefined;
    }
    else if (value === 'true') {
        return true;
    }
    else if (value === 'false') {
        return false;
    }
    else {
        throw new TypeError(`Expected boolean, got ${value}`);
    }
};
export const deserializeNumberValue = (value) => {
    if (value === null) {
        return undefined;
    }
    const parsed = Number(value);
    if (Number.isNaN(parsed)) {
        throw new TypeError(`Expected number, got ${value}`);
    }
    return parsed;
};
export const deserializeQueryParameters = (schema, searchParameters) => {
    const deserializedParameters = {};
    const wildcardRouteSearchShape = routes['*'].shape.search.unwrap().shape;
    const schemaShape = {
        ...schema.shape,
        ...wildcardRouteSearchShape,
    };
    for (const key in schemaShape) {
        if (key in schemaShape) {
            const searchParameter = searchParameters.get(key);
            const defaultValue = schemaShape[key] instanceof z.ZodDefault
                ? schemaShape[key].parse(undefined)
                : undefined;
            if (searchParameter === null && defaultValue !== undefined) {
                deserializedParameters[key] = defaultValue;
                continue;
            }
            const parameterSchema = schemaShape[key] instanceof z.ZodDefault
                ? schemaShape[key].removeDefault() instanceof z.ZodOptional
                    ? schemaShape[key].removeDefault().unwrap()
                    : schemaShape[key].removeDefault()
                : schemaShape[key] instanceof z.ZodOptional
                    ? schemaShape[key].unwrap()
                    : schemaShape[key];
            if (parameterSchema instanceof z.ZodBoolean) {
                deserializedParameters[key] = deserializeBooleanValue(searchParameter);
            }
            else if (parameterSchema instanceof z.ZodNumber) {
                deserializedParameters[key] = deserializeNumberValue(searchParameter);
            }
            else if (parameterSchema instanceof z.ZodArray) {
                const elements = searchParameter?.split(',') ?? [];
                if (elements.length !== 0) {
                    const elementSchema = parameterSchema.element;
                    deserializedParameters[key] = elements.map((element) => {
                        if (elementSchema instanceof z.ZodBoolean) {
                            return deserializeBooleanValue(element);
                        }
                        else if (elementSchema instanceof z.ZodNumber) {
                            return deserializeNumberValue(element);
                        }
                        return element;
                    });
                }
            }
            else {
                deserializedParameters[key] = searchParameter ?? undefined;
            }
        }
    }
    return deserializedParameters;
};
export const serializeQueryParameter = (value) => {
    if (value === undefined) {
        return '';
    }
    if (Array.isArray(value)) {
        return value.map(String).join(',');
    }
    return String(value);
};
//# sourceMappingURL=index.js.map